$(document).on('click', '.b-purchase__item-heading', function(e){
	$(this).closest('.b-purchase__item').find('.b-purchase__details').slideToggle();
	$(this).toggleClass('is-opened');
	$([document.documentElement, document.body]).animate({
		scrollTop: $(this).offset().top
	}, 1000);
});
$(document).on('click', '.b-purchase__show-more', function(e){
	var $itemsList = $(this).closest('.b-purchase__list');
	var numItems = $itemsList.attr('data-items-limit') || 5;
	$(this).closest('.b-purchase__list').find('.b-purchase__item:hidden').slice(0, numItems).show();
	if($(this).closest('.b-purchase__list').find('.b-purchase__item:hidden').length == 0){
		$(this).closest('.b-purchase__buttons').hide();
	}
});
$(function(){
	// Скрываем лишнее при загрузке
	$('.b-purchase__list').each(function(){
		var numItems = $(this).attr('data-items-limit') || 5;
		$(this).find('.b-purchase__item').slice(numItems).hide();
	});
});